import { useUI } from '../context/UIContext'

/** Fixed banner while the access token is being renewed via refresh token. */
export function SessionRefreshBanner() {
  const { isLoading } = useUI()
  if (!isLoading('sessionRefresh')) return null
  return (
    <div
      className="pointer-events-none fixed left-0 right-0 top-0 z-[100] flex justify-center px-4 pt-3"
      role="status"
      aria-live="polite"
    >
      <div className="rounded-full border border-indigo-200/80 bg-white/95 px-4 py-2 text-sm font-medium text-slate-700 shadow-lg backdrop-blur-sm dark:border-indigo-500/30 dark:bg-slate-900/95 dark:text-slate-100">
        Refreshing your session…
      </div>
    </div>
  )
}
